import { useMemo } from 'react'

import { getVatRatesSortedByPriorities } from '../utils/getVatRatesSortedByPriorities'
import { useFetchSalesVatRatesWithRules } from './useFetchSalesVatRatesWithRules'

export const useGetVatRates = () => {
  const { taxRates, isLoading } = useFetchSalesVatRatesWithRules()

  const vatRates = useMemo(() => (isLoading ? [] : getVatRatesSortedByPriorities(taxRates)), [isLoading, taxRates])

  return {
    isLoading,
    vatRates,
  }
}
